import React from 'react';
import CourtPlanLogo from './CourtPlanLogo';

export const EmptyState = ({ icon: Icon, text, hint, actionLabel, onAction, compact = false, testId }) => (
  <div
    className={`relative flex flex-col items-center justify-center text-center overflow-hidden ${compact ? 'py-5 px-3' : 'py-8 px-4'}`}
    data-testid={testId}
  >
    <div className="hidden sm:block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.06] grayscale pointer-events-none select-none">
      <CourtPlanLogo size={compact ? 'sm' : 'md'} />
    </div>
    {Icon && (
      <div className={`rounded-full bg-red-700/10 text-red-700 flex items-center justify-center mb-2.5 ${compact ? 'w-9 h-9' : 'w-12 h-12'}`}>
        <Icon className={compact ? 'w-4 h-4' : 'w-5 h-5'} />
      </div>
    )}
    <p className="text-sm text-slate-600 font-medium">{text}</p>
    {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
    {actionLabel && onAction && (
      <button
        onClick={onAction}
        data-testid={testId ? `${testId}-action` : undefined}
        className="mt-3 h-9 px-4 rounded-lg bg-red-700 text-white text-sm font-semibold hover:bg-red-800 transition-colors"
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
